module.exports = __webpack_public_path__ + "img/userimg.bf91ac67.svg";